import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    CheckboxGroupInput,
    required,
} from 'react-admin';

const DAY_CHOICES = [
    { id: 1, name: 'Monday' },
    { id: 2, name: 'Tuesday' },
    { id: 3, name: 'Wednesday' },
    { id: 4, name: 'Thursday' },
    { id: 5, name: 'Friday' },
    { id: 6, name: 'Saturday' },
    { id: 7, name: 'Sunday' },
];

const validateWorkDays = (value: number[] | undefined) => {
    if (!value || value.length !== 5) {
        return 'Exactly 5 work days must be selected';
    }
    return undefined;
};

export const WorkScheduleEdit: React.FC = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="name" label="Schedule Name" validate={required()} />
            <CheckboxGroupInput
                source="work_days"
                label="Work Days (select exactly 5)"
                choices={DAY_CHOICES}
                validate={validateWorkDays}
            />
        </SimpleForm>
    </Edit>
);
